import KpiCard from "@/components/base/KpiCard";
import DonutChart from "@/components/feature/DonutChart";
import SectionCard from "./SectionCard";
import { SimpleLineChart, HBarList, SliceLegend } from "./charts";
import {
  customersKpis,
  newCustomers,
  customerFrequency,
  topCustomers,
  customersTable,
} from "@/mocks/salesReports";

const freqSegments = customerFrequency.map((c) => ({ label: c.name, pct: c.value, color: c.color }));

export default function CustomersTab() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {customersKpis.map((k) => (
          <KpiCard key={k.label} {...k} />
        ))}
      </div>

      <SectionCard title="العملاء الجدد — آخر 6 شهور">
        <SimpleLineChart
          data={newCustomers}
          xKey="month"
          yKey="value"
          name="عملاء جدد"
          color="#00AAB7"
          height={280}
        />
      </SectionCard>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <SectionCard title="توزيع العملاء حسب عدد الطلبات">
          <div className="flex flex-col items-center">
            <DonutChart segments={freqSegments} size={190} thickness={30} centerValue="186" centerLabel="عميل" />
            <SliceLegend items={freqSegments} />
          </div>
        </SectionCard>

        <SectionCard title="أكثر 5 عملاء طلباً">
          <HBarList items={topCustomers} color="#27AE60" suffix=" طلب" />
        </SectionCard>
      </div>

      <SectionCard title="بيانات العملاء">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[620px] text-sm">
            <thead>
              <tr className="text-xs font-semibold text-ghasla-text-secondary">
                <th className="h-11 px-3 text-right">العميل</th>
                <th className="h-11 px-3 text-right">عدد الطلبات</th>
                <th className="h-11 px-3 text-right">إجمالي الإنفاق</th>
                <th className="h-11 px-3 text-right">الخدمة المفضلة</th>
                <th className="h-11 px-3 text-right">آخر طلب</th>
              </tr>
            </thead>
            <tbody>
              {customersTable.map((c) => (
                <tr key={c.name} className="border-t border-[#F4F8F8] hover:bg-[#FAFEFE]">
                  <td className="h-12 px-3">
                    <span className="flex items-center gap-2.5">
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#E6F7F8] text-xs font-semibold text-[#0D6E6E]">
                        {c.name.charAt(0)}
                      </span>
                      <span className="font-medium text-ghasla-text-heading">{c.name}</span>
                    </span>
                  </td>
                  <td className="h-12 px-3 text-ghasla-text-primary">{c.orders}</td>
                  <td className="h-12 px-3 font-medium text-ghasla-text-heading">{c.spend}</td>
                  <td className="h-12 px-3">
                    <span className="rounded-full bg-[#F0FDFD] px-3 py-1 text-xs text-ghasla-text-link">
                      {c.favorite}
                    </span>
                  </td>
                  <td className="h-12 px-3 text-ghasla-text-secondary">{c.last}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SectionCard>
    </div>
  );
}